/** Return URL after login when the user started from famla-automate. */

const STORAGE_KEY = 'automation_return_url';

function getAutomateAppOrigin(): string {
    const raw = (process.env.REACT_APP_AUTOMATE_URL || 'https://test.automation.famla.ai').trim();
    try {
        return new URL(raw).origin;
    } catch {
        return raw.replace(/\/+$/, '');
    }
}

function allowedAutomationOrigins(): Set<string> {
    const origins = new Set<string>([getAutomateAppOrigin()]);

    if (typeof window !== 'undefined') {
        const { hostname, protocol, port } = window.location;
        if (hostname === 'localhost' || hostname === '127.0.0.1') {
            origins.add(`${protocol}//${hostname}:8040`);
            origins.add(`${protocol}//${hostname}${port ? `:${port}` : ''}`);
        }
    }

    origins.add('http://localhost:8040');
    origins.add('http://127.0.0.1:8040');

    return origins;
}

/** Only allow absolute URLs pointing at the configured automation app. */
export function safeAutomationReturnUrl(raw: string | null | undefined): string | null {
    if (!raw || typeof raw !== 'string') return null;

    try {
        const url = new URL(raw.trim());
        if (url.protocol !== 'http:' && url.protocol !== 'https:') return null;
        if (!allowedAutomationOrigins().has(url.origin)) return null;
        return url.href;
    } catch {
        return null;
    }
}

/** Persist ?redirect= on /auth/login so OAuth flows do not lose the return URL. */
export function persistAutomationRedirectQuery(redirectQueryParam: string | null | undefined): void {
    const safe = safeAutomationReturnUrl(redirectQueryParam);
    if (safe) sessionStorage.setItem(STORAGE_KEY, safe);
}

export function peekAutomationRedirect(redirectQueryParam: string | null): string | null {
    const fromQuery = safeAutomationReturnUrl(redirectQueryParam);
    if (fromQuery) return fromQuery;
    return safeAutomationReturnUrl(sessionStorage.getItem(STORAGE_KEY));
}

export function clearAutomationRedirectStorage(): void {
    sessionStorage.removeItem(STORAGE_KEY);
}

export function navigateToAutomationRedirect(url: string): void {
    const safe = safeAutomationReturnUrl(url);
    if (!safe) return;
    clearAutomationRedirectStorage();
    window.location.assign(safe);
}
